import { Box, BoxProps, ColorOptions, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { useStores } from '../../../data/store'
import { dateFormatter, DateFormatTypes, getFrequency, getType } from '../../../util/util'

const TextLayout = ({ title, subTitle }) => {
  return (
    <Box>
      <TextNew type="body12" color="BRAND_COLOR_GRAY_1" fontFamily={'jiotype-medium'}>
        {title}
      </TextNew>
      <TextNew type="titleBold16" color="BLACK_21" fontFamily={'jiotype-bold'}>
        {subTitle}
      </TextNew>
    </Box>
  )
}

const Labels = ({ title, subTitle }) => {
  if (!subTitle || subTitle === 'NA') {
    return null
  }
  return (
    <Box flexDirection={'row'} paddingRight={24}>
      <Box f={0.4} pv={4}>
        <TextNew type="label" fontSize={12} color="BRAND_COLOR_GRAY_1" fontFamily={'jiotype-medium'}>
          {title}
        </TextNew>
      </Box>
      <Box f={0.6} pv={4}>
        <TextNew color="BLACK_21" type={'label'} fontSize={12} fontFamily={'jiotype-medium'}>
          {subTitle}
        </TextNew>
      </Box>
    </Box>
  )
}

interface InfoProps {
  id: string
}
const Info: FC<InfoProps> = ({ id }: InfoProps) => {
  const { getSubscriptionListDetails } = useStores((store: any) => ({
    getSubscriptionListDetails: store.subscriptions.getSubscriptionListDetails,
  }))
  const data = getSubscriptionListDetails(id)

  return (
    <Box {...styles.container}>
      <Box {...styles.subContainer}>
        <Box f={1}>
          <TextLayout title={'Customer ID'} subTitle={data?.customer?.externalId} />
          <TextNew fontSize={12} color={'GREY_77' as ColorOptions} fontWeight={'300'} fontFamily="jiotype-light">
            {data?.customer?.id}
          </TextNew>
        </Box>
        <Box f={1}>
          <TextLayout title={'Maximum Amount'} subTitle={`₹ ${data?.amount}`} />
        </Box>
      </Box>
      <Spacer size={24} direction={'vertical'} />
      <Box {...styles.subContainer}>
        <Box f={1}>
          <Labels title={'Name'} subTitle={data?.customer?.name} />
          <Labels title={'E-mail'} subTitle={data?.customer?.email} />
          <Labels title={'Phone'} subTitle={data?.customer?.mobile} />
        </Box>
        <Box f={1}>
          <Labels title={'Type'} subTitle={getType[data?.type]} />
          <Labels title={'Frequency'} subTitle={getFrequency[data?.frequency]} />
          <Labels title={'Start Date'} subTitle={dateFormatter(data?.scheduledAt, DateFormatTypes.MONTH_STRING_ISO)} />
          <Labels title={'End Date'} subTitle={dateFormatter(data?.scheduledEnd, DateFormatTypes.MONTH_STRING_ISO)} />
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    p: 24,
  } as BoxProps,
  subContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  } as BoxProps,
}
export { Info }
